var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBullets(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.85482 6.00033H14.5215M8.85482 10.0003H14.5215M8.85482 14.0003H14.5215M6.68815 6.00033C6.68815 6.18442 6.53891 6.33366 6.35482 6.33366C6.17072 6.33366 6.02148 6.18442 6.02148 6.00033C6.02148 5.81623 6.17072 5.66699 6.35482 5.66699C6.53891 5.66699 6.68815 5.81623 6.68815 6.00033ZM6.68815 10.0003C6.68815 10.1844 6.53891 10.3337 6.35482 10.3337C6.17072 10.3337 6.02148 10.1844 6.02148 10.0003C6.02148 9.81623 6.17072 9.66699 6.35482 9.66699C6.53891 9.66699 6.68815 9.81623 6.68815 10.0003ZM6.68815 14.0003C6.68815 14.1844 6.53891 14.3337 6.35482 14.3337C6.17072 14.3337 6.02148 14.1844 6.02148 14.0003C6.02148 13.8162 6.17072 13.667 6.35482 13.667C6.53891 13.667 6.68815 13.8162 6.68815 14.0003Z",
    stroke: "#4B5563",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBullets);
export default __webpack_public_path__ + "static/media/bullets.fa8eb9516a5fb7221b991beedad9b520.svg";
export { ForwardRef as ReactComponent };